import { useNavigate, useParams, useSearchParams } from "react-router";

import { NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS, PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

export const useGetParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.RESERVATION_PAGE.SNACK.EDIT.NEW>>();

	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const duplicateItemID = searchParams.get(NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS) ?? undefined;

	/**
	 *
	 * @todo hotelID ブランク時の振る舞いを設計
	 *
	 */
	if (!hotelID) {
		notifyUserEventInfo({
			title: "無効なURLです",
		});
		navigate(PATHS.TOP);
	}

	return {
		hotelID: hotelID!,
		duplicateItemID,
	};
};
